import { withAuthenticationRequired } from '@auth0/auth0-react';
import styles from './ShopPage.module.css';

const creditPacks = [
  { credits: 50, price: '$1.99', bonus: ' ' },
  { credits: 200, price: '$4.99', bonus: '+60% Bonus' },
  { credits: 750, price: '$9.99', bonus: '+200% Bonus' },
  { credits: 2000, price: '$19.99', bonus: '+300% Bonus', recommended: true },
];

function ShopPage() {
  return (
    <div>
      <div className="page-header">
        <h2>The Ego Shop</h2>
      </div>

      <div className={styles.comingSoonBanner}>
        <h3>Feature Coming Soon!</h3>
        <p>
          The ability to purchase additional Ego Credits and other items will be
          available after the private beta.
        </p>
      </div>

      <h3 className={styles.sectionHeader}>Ego Credit Packs</h3>
      <p className={styles.sectionSubtitle}>
        Top up your Ego Credits (⚡️) to continue conversations, analyze images,
        and generate content.
      </p>

      <div className={styles.grid}>
        {creditPacks.map((pack, index) => (
          <div
            key={index}
            className={`${styles.card} ${pack.recommended ? styles.recommended : ''}`}
          >
            {pack.recommended && (
              <div className={styles.recommendedBadge}>Best Value</div>
            )}

            <h4>⚡️{pack.credits.toLocaleString()}</h4>
            <p className={styles.price}>{pack.price}</p>

            {pack.bonus && (
              <span className={styles.bonusBadge}>{pack.bonus}</span>
            )}

            <button
              className="action-button primary"
              disabled
              title="Coming Soon!"
            >
              Purchase
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default withAuthenticationRequired(ShopPage);
